import { isPostalCodeExcludedCountry } from "@equidefi/constants/countries";
import { useEffect } from "react";

/**
 * Drives the "hide the postal code for countries that don't use one" behaviour.
 */
export const usePostalCodeExcluded = (
  country: string | null | undefined,
  currentPostal: string | null | undefined,
  clear: () => void,
): boolean => {
  const isExcluded = isPostalCodeExcludedCountry(country);

  // biome-ignore lint/correctness/useExhaustiveDependencies: clear only when the excluded state flips, not when the postal value or setter identity changes
  useEffect(() => {
    if (isExcluded && currentPostal) clear();
  }, [isExcluded]);

  return isExcluded;
};
